exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".j-object-form[data-v-5365bfd8] .el-form-item__label:before{content:\"\"!important;color:unset!important;margin-right:unset!important}.j-object-form[data-v-5365bfd8] .j-object-form-label.required:before{content:\"*\";color:#f56c6c;margin-right:4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?minimize!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5365bfd8","scoped":true,"hasInlineConfig":false}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./packages/element-ui-expand/src/JElObjectForm.vue
// module id = 68
// module chunks = 0